export type RolesType = 'developer' | 'supplier' | 'organisation_manager'
export type RoleAccessType = {
  [k in RolesType]?: NavItemKeysType[]
}

export type NavItemKeysType = keyof typeof navItems
export type NavItemsType = typeof navItems
export type NavItemsValueType = { title: string; path: string }

// Navigation Items
export const navItems = {
  home: { title: 'Home', path: '/' },
  organisation: { title: 'Organisation', path: '/organisation/current' },
  management: { title: 'Management', path: '/management' },
  report: { title: 'Report', path: '/report' },
  permissions: { title: 'Permissions', path: '/permission' },
  partners: { title: 'Partners', path: '/supplier' },
  organisations: { title: 'Organisations', path: '/organisation' },
  users: { title: 'Users', path: '/user' },
  userGroups: { title: 'User groups', path: '/user-group' },
  citizens: { title: 'Citizens', path: '/citizen' },
  gateway: { title: 'Gateway', path: '/gateway' },
  devices: { title: 'Devices', path: '/device' },
  provisionDevice: { title: 'Provision device', path: '/provision-device' },
  rules: { title: 'Rules', path: '/rules' },
  zones: { title: 'Zones', path: '/zone' },
  notifications: { title: 'Notifications', path: '/notifications' },
  tags: { title: 'Tags', path: '/tag' },
  packages: { title: 'Packages', path: '/package' },
  beacon: { title: 'Beacon', path: '/beacon' },
  sensors: { title: 'Sensors', path: '/sensor' },
  batchHistory: { title: 'Batch Job History', path: '/batch-history' },
  support: { title: 'Support', path: '/support' },
  userCleanup: { title: 'User cleanup', path: '/user-cleanup' },
  operationModes: { title: 'Operation modes', path: '/operation-modes' },
  rulesOverview: { title: 'Rules overview', path: '/rules-overview' },
  unlicensedTags: { title: 'Unlicensed tags', path: '/unlicensed-tag' },
  search: { title: 'Search', path: '/search' },
  auditLog: { title: 'Audit log', path: '/audit-log' },
  maintenance: { title: 'Maintenance', path: '/maintenance' },
}

// Define which links are accessible for each role
export const roleAccess: RoleAccessType = {
  supplier: [
    'organisation',
    'management',
    'report',
    'organisations',
    'users',
    'permissions',
    'userGroups',
    'citizens',
    'gateway',
    'devices',
    'provisionDevice',
    'rules',
    'zones',
    'notifications',
    'tags',
    'beacon',
    'batchHistory',
    'support',
    'search',
    'auditLog',
  ],
  organisation_manager: ['management', 'report', 'provisionDevice'],
}

export const getNavItems = (role?: RolesType): NavItemsValueType[] => {
  if (!role) {
    return []
  }

  if (!roleAccess[role]) {
    return Object.keys(navItems).map((key) => navItems[key])
  }

  return roleAccess[role].map((key) => navItems[key])
}
